import * as React from 'react';
import { FC } from 'react';

import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl';

import PointsIcon from 'components/icons/loyalty-points-icon';
import { t } from 'state/intl/translations';

const PointsEarned: FC<React.PropsWithChildren<{
  loyaltyTransaction: { pointsEarned: number; bonusPointsEarned: number };
}>> = ({ loyaltyTransaction }) => {
  const pointsEarned = loyaltyTransaction.pointsEarned + loyaltyTransaction.bonusPointsEarned;

  if (!pointsEarned) {
    return null;
  }

  return (
    <View style={styles.container}>
      <PointsIcon mr="$1" size={5} />
      <Typography variant="headerFour" style={styles.pointsText}>
        {t('crownsEarned', { points: pointsEarned })}
      </Typography>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignContent: 'center',
  },
  pointsText: {
    margin: 0,
    lineHeight: 20,
  },
});

export { PointsEarned as PointsEarnedBlock };
